module.exports = __webpack_public_path__ + "img/new-loader.011349f4.png";